<template>
  <div>
    <div v-show="isLoading">
      <div
        class="loading-page"
        style="background-color: #f7f7f785;"
      >
        <i
          class="fa-spin fas fa-spinner fa-4x"
          style="color: var(--primary);"
        />
      </div>
    </div>
    <div
      v-if="showErro"
      class="w-100 text-center erro-text"
    >
      <h2 class="mb-1">
        Você não tem autorização!</h2>
      <p class="mb-2">
        Você não tem permissão para acessar essa página</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loading-page {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  z-index: 99999 !important;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .i {
    position: absolute;
    opacity: 1;
  }
}

.erro-text {
  margin-top: 20rem;
}
</style>

<script>
import apiPessoa from '@/app-modulo/comercial/pessoa/shared/services/api'
import { persistPortalSession, updateAbility } from '@/auth/utils'

export default {
  name: 'Landing',
  data() {
    return {
      form: {
        pessoaId: this.$route.query.pessoaId,
        email: this.$route.query.email,
        token: this.$route.query.token,
      },
      isLoading: true,
      showErro: false,
    }
  },
  created() {
    apiPessoa.autorizar(this.form)
      .then(response => {
        this.isLoading = false
        persistPortalSession({
          userData: response.data.userData,
          accessToken: response.data.accessToken,
        })
        updateAbility(this.$ability, response.data.userData?.ability)
        this.$router.push({ name: 'portalproposta-externo' })
      })
      .catch(err => {
        this.isLoading = false
        this.showErro = true
        throw err
      })
  },
}
</script>
